<template>
  <ul :class="['space-y-2 w-150 rounded radio-button-set', {
    'p-2 border border-solid border-danger invalid': invalid,
  }]">
    <li v-for="(val, index) in options" :key="`${index}-${val}`">
        <RadioButton
        :size="size"
        :value="value"
        :checked="val === value" @change="$emit('input', val)">{{ val.name }}</RadioButton>
    </li>
  </ul>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue';

export default {
  name: 'RadioButtonSet',
  components: {
    RadioButton,
  },
  props: ['value', 'options', 'size', 'invalid'],
};
</script>
